export const FAQ_ITEMS = [
    {
        title: "Hinzufügen von Benutzern aus einer anderen Firma",
        url: "https://www.youtube.com/watch?v=gv9-Pq6pRKM",
        id: "gv9-Pq6pRKM"
    },
    {
        title: "Benutzer anlegen",
        url: "https://www.youtube.com/watch?v=yh3dw4Xx7MM",
        id: "yh3dw4Xx7MM"
    },
    {
        title: "Verschiedene Meldungen",
        url: "https://www.youtube.com/watch?v=ISu9ELzucQ8",
        id: "ISu9ELzucQ8"
    },
    {
        title: "So fügen Sie einen Grundriss hinzu und zeigen ihn an",
        url: "https://www.youtube.com/watch?v=Xk6mBn3nmnQ",
        id: "Xk6mBn3nmnQ"
    },
    {
        title: "Konfiguration des Profils",
        url: "https://www.youtube.com/watch?v=hHwlCwKLr_U",
        id: "hHwlCwKLr_U"
    },
    {
        title: "So erstellen Sie einen Standort",
        url: "https://www.youtube.com/watch?v=KqsEmGhNR08",
        id: "KqsEmGhNR08"
    },
    {
        title: "Wie Sie Fallen versetzen",
        url: "https://www.youtube.com/watch?v=-unmSLr1Bt8",
        id: "-unmSLr1Bt8"
    },
    {
        title: "So installieren Sie Geräte",
        url: "https://www.youtube.com/watch?v=htY4Tp9K8-o",
        id: "htY4Tp9K8-o"
    },
    {
        title: "Wie Sie die API benutzen",
        url: "https://www.youtube.com/watch?v=QqjkH6mHvz4",
        id: "QqjkH6mHvz4"
    },
    {

        title: "So arbeiten Sie mit Geräten",
        url: "https://www.youtube.com/watch?v=XoRmpy8a6rE",
        id: "XoRmpy8a6rE"
    },
    {
        title: "Rollen verwalten und zuweisen",
        url: "https://www.youtube.com/watch?v=wXuBDKl3BuI",
        id: "wXuBDKl3BuI"
    },
    {
        title: "Daten teilen",
        url: "https://www.youtube.com/watch?v=tuo8UDg6tcg",
        id: "tuo8UDg6tcg"
    }
]